import { render, staticRenderFns } from "./base-wizard-blank-layout.vue?vue&type=template&id=ad4b05d4&scoped=true&"
import script from "./base-wizard-blank-layout.vue?vue&type=script&lang=ts&"
export * from "./base-wizard-blank-layout.vue?vue&type=script&lang=ts&"
import style0 from "./base-wizard-blank-layout.vue?vue&type=style&index=0&id=ad4b05d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4b05d4",
  null
  
)

export default component.exports